export type ENVIRONMENT = "development" | "test" | "staging" | "production";

const HOSTNAME_TO_ENVIRONMENT: Record<string, ENVIRONMENT> = {
  "client.roqua.nl": "production",
  "client.roqua-staging.nl": "staging",
  "client.roqua.eu": "development",
  localhost: "development",
};

export function getEnvironment(): ENVIRONMENT {
  // The dev server can be reached on other hostnames too, like a worktree's own port on a tailnet
  // (see bin/assign-dev-ports), but is never production.
  if (import.meta.env.DEV) {
    return "development";
  }

  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const env = HOSTNAME_TO_ENVIRONMENT[hostname];

    if (env) {
      return env;
    }
  }

  // Fallback to production if no match is found, which has
  // the least chance of breaking production.
  return "production";
}

export const environment = getEnvironment();
